import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, GroupItem, Grouping } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";
import { CheckBox } from "devextreme-react";

export const INV_MovimientoInventario = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const [agrupado, setAgrupado] = useState(false)
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const [FechaDesde, setFechaDesde] = useState(new Date(DiasParaDesdeListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaDesdeListados) : Date.now()));
  const [FechaHasta, setFechaHasta] = useState(new Date(DiasParaHastaListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaHastaListados) : Date.now()));
  const { Varios: { FormateoFechaPara_yyyyMMdd,
    ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { INV_MovimientoInventario: { function_INV_MovimientoInventario_Listar } } = require('neftis7_apicaller');

  const onValueChangedFechaDesde = (nuevaFecha) => {
    setFechaDesde(nuevaFecha.value);
  };

  const onValueChangedFechaHasta = (nuevaFecha) => {
    setFechaHasta(nuevaFecha.value);
  };

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      let resultData = await function_INV_MovimientoInventario_Listar(await FormateoFechaPara_yyyyMMdd(FechaDesde), await FormateoFechaPara_yyyyMMdd(FechaHasta));

      const dataConMovimiento = resultData.data.map(item => ({
        ...item,
        Movimiento: (item.Cantidad || 0) - (item.CantidadAnterior || 0)
      }));

      if (agrupado) {
        const clavesAgrupacion = [
          "Articulo",
          "CodigoArticulo",
          "CodigoCompania",
          "CodigoPlanta",
          "CodigoPresentacion",
          "CodigoTamano",
          "CodigoUbicacion",
          "CodigoUnidadMedida",
          "INV_MovimientoInventario_Tipos_Descripcion",
          "IdTipoMovimientoInventario",
          "Presentacion",
          "Tamano",
          "Ubicacion",
          "UnidadMedida"
        ];

        const agrupado = {};

        for (const item of dataConMovimiento) {
          // Creamos una clave única combinando los campos de agrupación
          const clave = clavesAgrupacion.map(k => item[k]).join("|");

          if (!agrupado[clave]) {
            // Creamos el grupo base copiando solo los campos de agrupación
            agrupado[clave] = {
              Movimiento: 0
            };

            for (const campo of clavesAgrupacion) {
              agrupado[clave][campo] = item[campo];
            }
          }

          // Sumamos movimiento
          agrupado[clave].Movimiento += item.Movimiento || 0;
        }

        const dataAgrupada = Object.values(agrupado);

        setData(dataAgrupada);
      }
      else {
        setData(dataConMovimiento);
      }
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    // Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta]); // Llamar a getData cuando FechaDesde o FechaHasta cambien

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getDataParametros();
  }, []);

  useEffect(() => {    
    getData();
  }, [agrupado]);

  return (
    <PaginaCreacionLibre
      Titulo="MOVIMIENTOS DE INVENTARIO"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>
                <td width={120}>
                  <label>Rango de Datos</label>
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={onValueChangedFechaDesde} />
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={onValueChangedFechaHasta} />
                </td>

                <td width={160}>
                  <CheckBox value={agrupado} onValueChanged={(e) => setAgrupado(e.value)} text="AGRUPADO" />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={data}
                id="gridContainer"
                keyExpr="CodigoArticulo"
              >
                <Grouping autoExpandAll={true} />
                <Summary>
                  <TotalItem
                    column="CodigoArticulo"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                  <GroupItem
                    column="Movimiento"
                    summaryType="sum"
                    showInGroupFooter={true} />
                </Summary>

                <Column caption="Código" dataField="IdMovimiento" width="100" alignment="Right" dataType="number" visible={!agrupado} />
                <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={!agrupado} />

                <Column caption="Artículo" alignment="Center">
                  <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Articulo" width="100%" minWidth={200} alignment="Left" dataType="string" />
                </Column>
                <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                  <Column caption="Código" dataField="CodigoPresentacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                  <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                </Column>
                <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano} >
                  <Column caption="Código" dataField="CodigoTamano" width="90" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                  <Column caption="Descripción" dataField="Tamano" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                </Column>

                <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                  <Column caption="Código" dataField="CodigoUnidadMedida" width="90" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  <Column caption="Descripción" dataField="UnidadMedida" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                </Column>
                <Column caption="Ubicación" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                  <Column caption="Código" dataField="CodigoUbicacion" width="90" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  <Column caption="Descripción" dataField="Ubicacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                </Column>

                <Column caption="Cantidades" alignment="Center" >
                  <Column caption="Anterior" dataField="CantidadAnterior" width="100" alignment="Right" dataType="number" visible={!agrupado} />
                  <Column caption="Mvmnto." dataField="Movimiento" width="100" alignment="Right" dataType="number" />
                  <Column caption="Actual" dataField="Cantidad" width="100" alignment="Right" dataType="number" visible={!agrupado} />
                </Column>

                <Column caption="Tipo" dataField="INV_MovimientoInventario_Tipos_Descripcion" width="200" alignment="Left" dataType="string" />
                <Column caption="Cód.Operación" dataField="IdOperacion" width="100" alignment="Right" dataType="number" />
                <Column caption="Cód.Item" dataField="IdItem" width="100" alignment="Right" dataType="number" visible={!agrupado} />
                <Column caption="Cód.Item" dataField="IdTipoMovimientoInventario" width="100" alignment="Right" dataType="number" visible={false} />
                <Column caption="Planta" dataField="CodigoPlanta" width="100" alignment="Left" dataType="string" />
                <Column caption="Motivo" dataField="Motivo" width="200" alignment="Left" dataType="string" visible={!agrupado} />

              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaCreacionLibre>
  );
};
